import React from "react";
import RegisterForm from "../components/organisms/RegisterForm";

const RegisterPage = ({ onRegister }) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <RegisterForm onRegister={onRegister} />
    </div>
  );
};

export default RegisterPage;
